import * as Yup from 'yup';

export const customFunctionSchema = {
  functionName: '',
  methodType: '',
  formatType: '',
  length: '',
  numbers: '',
  numbers1: '',
  numbers2: '',
  subject: '',
  endopt: '',
  noSplitopt: '',
  datentime: '',
  type: '',
  restToLower: '',
  startLength: '',
  endLength: '',
  startString: '',
  endString: '',
  textFields: [],
  separator: '',
};

export const customFunctionSchemaValidation = Yup.lazy((values) => {
  if (values.methodType === undefined || values.methodType === null) {
    return Yup.object().shape({
      functionName: Yup.string()
        .required('Name is Required.')
        .matches(/^[0-9A-Za-z\s]+$/, 'Name should not contain special characters or numbers.')
        .max(100, 'Name can not be more than 100 characters.'),
      methodType: Yup.object().required('Choose Method'),
    });
  }
  switch (values.methodType.value) {
    case 'FORMAT_DATE':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        formatType: Yup.object().required('Formatting is Required'),
        datentime: Yup.object().required('Choose field'),
      });
    case 'DIVIDE':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        formatType: Yup.object().required('Formatting is Required'),
        number1: Yup.object().required('Choose Field'),
        number2: Yup.object().required('Choose Field'),
      });
    case 'CUSTOM_CALCULATION':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        formatType: Yup.object().required('Formatting is Required'),
        subject: Yup.string().required('Choose Field'),
      });
    case 'ADDITION':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        formatType: Yup.object().required('Formatting is Required'),
        numbers: Yup.array()
          .min(2, 'Pick at least 2 fields')
          .of(
            Yup.object().shape({
              label: Yup.string().required(),
              value: Yup.string().required(),
            }),
          )
          .required('Choose Field'),
      });
    case 'AVERAGE':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        formatType: Yup.object().required('Formatting is Required'),
        numbers: Yup.array()
          .min(2, 'Pick at least 2 fields')
          .of(
            Yup.object().shape({
              label: Yup.string().required(),
              value: Yup.string().required(),
            }),
          )
          .required('Choose Field'),
      });
    case 'MULTIPLY':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        formatType: Yup.object().required('Formatting is Required'),
        numbers: Yup.array()
          .min(2, 'Pick at least 2 fields')
          .of(
            Yup.object().shape({
              label: Yup.string().required(),
              value: Yup.string().required(),
            }),
          )
          .required('Choose Method'),
      });
    case 'SUBSTRACTION':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        formatType: Yup.object().required('Formatting is Required'),
        numbers1: Yup.array()
          .of(
            Yup.object().shape({
              label: Yup.string().required(),
              value: Yup.string().required(),
            }),
          )
          .required('Choose Method'),
        numbers2: Yup.array()
          .of(
            Yup.object().shape({
              label: Yup.string().required(),
              value: Yup.string().required(),
            }),
          )
          .required('Choose Method'),
      });
    case 'COUNT':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        subject: Yup.object().required('Choose Field'),
      });
    case 'CAPITALIZE':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        restToLower: Yup.object().required('Select One'),
        subject: Yup.object().required('Choose Field'),
      });
    case 'LOWER_CASE':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        subject: Yup.object().required('Choose Field'),
      });
    case 'UPPER_CASE':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        subject: Yup.object().required('Choose Field'),
      });
    case 'SLUGIFY':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        subject: Yup.object().required('Choose Field'),
      });
    case 'TRIM':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        subject: Yup.object().required('Choose Field'),
        type: Yup.object().required('Choose One'),
      });
    case 'TITLE_CASE':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        subject: Yup.object().required('Choose Field'),
        noSplitopt: Yup.string().required('Character not to split'),
      });
    case 'TRUNCATE':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        subject: Yup.object().required('Choose Field'),
        length: Yup.number().required('Give Length'),
        endopt: Yup.string().required('Ending string'),
      });
    case 'SUB_STRING':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        subject: Yup.object().required('Choose Field'),
        startLength: Yup.number().required('Give the Starting Length'),
      });
    case 'STRING_JOIN':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        textFields: Yup.array()
          .min(1, 'Choose at least one field')
          .of(
            Yup.object().shape({
              label: Yup.string().required(),
              value: Yup.string().required(),
            }),
          )
          .required('Choose at least one field'),
      });
    case 'MARKDOWN_TO_HTML':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        subject: Yup.object().required('Choose Field'),
      });
    case 'MASKING':
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        subject: Yup.object().required('Choose Field'),
      });
    default:
      return Yup.object().shape({
        functionName: Yup.string()
          .required('Name is Required')
          .max(100, 'Name can not be more than 100 characters'),
        methodType: Yup.object().required('Choose Method'),
      });
  }
});
